// A
let standardLabels = {
  21: "A0",
  22: "A♯0",
  23: "B0",
  24: "C1",
  25: "C♯1",
  26: "D1",
  27: "D♯1",
  28: "E1",
  29: "F1",
  30: "F♯1",
  31: "G1",
  32: "G♯1",
  33: "A1",
  34: "A♯1",
  35: "B1",
  36: "C2",
  37: "C♯2",
  38: "D2",
  39: "D♯2",
  40: "E2",
  41: "F2",
  42: "F♯2",
  43: "G2",
  44: "G♯2",
  45: "A2",
  46: "A♯2",
  47: "B2",
  48: "C3",
  49: "C♯3",
  50: "D3",
  51: "D♯3",
  52: "E3",
  53: "F3",
  54: "F♯3",
  55: "G3",
  56: "G♯3",
  57: "A3",
  58: "A♯3",
  59: "B3",
  60: "C4",
  61: "C♯4",
  62: "D4",
  63: "D♯4",
  64: "E4",
  65: "F4",
  66: "F♯4",
  67: "G4",
  68: "G♯4",
  69: "A4",
  70: "A♯4",
  71: "B4",
  72: "C5",
  73: "C♯5",
  74: "D5",
  75: "D♯5",
  76: "E5",
  77: "F5",
  78: "F♯5",
  79: "G5",
  80: "G♯5",
  81: "A5",
  82: "A♯5",
  83: "B5",
  84: "C6",
  85: "C♯6",
  86: "D6",
  87: "D♯6",
  88: "E6",
  89: "F6",
  90: "F♯6",
  91: "G6",
  92: "G♯6",
  93: "A6",
  94: "A♯6",
  95: "B6",
  96: "C7",
  97: "C♯7",
  98: "D7",
  99: "D♯7",
  100: "E7",
  101: "F7",
  102: "F♯7",
  103: "G7",
  104: "G♯7",
  105: "A7",
  106: "A♯7",
  107: "B7",
  108: "C8",
};

// B♭
let standardLabels2 = {
  21: "A0",
  22: "B♭0",
  23: "B0",
  24: "C1",
  25: "D♭1",
  26: "D1",
  27: "E♭1",
  28: "E1",
  29: "F1",
  30: "G♭1",
  31: "G1",
  32: "A♭1",
  33: "A1",
  34: "B♭1",
  35: "B1",
  36: "C2",
  37: "D♭2",
  38: "D2",
  39: "E♭2",
  40: "E2",
  41: "F2",
  42: "G♭2",
  43: "G2",
  44: "A♭2",
  45: "A2",
  46: "B♭2",
  47: "B2",
  48: "C3",
  49: "D♭3",
  50: "D3",
  51: "E♭3",
  52: "E3",
  53: "F3",
  54: "G♭3",
  55: "G3",
  56: "A♭3",
  57: "A3",
  58: "B♭3",
  59: "B3",
  60: "C4",
  61: "D♭4",
  62: "D4",
  63: "E♭4",
  64: "E4",
  65: "F4",
  66: "G♭4",
  67: "G4",
  68: "A♭4",
  69: "A4",
  70: "B♭4",
  71: "B4",
  72: "C5",
  73: "D♭5",
  74: "D5",
  75: "E♭5",
  76: "E5",
  77: "F5",
  78: "G♭5",
  79: "G5",
  80: "A♭5",
  81: "A5",
  82: "B♭5",
  83: "B5",
  84: "C6",
  85: "D♭6",
  86: "D6",
  87: "E♭6",
  88: "E6",
  89: "F6",
  90: "G♭6",
  91: "G6",
  92: "A♭6",
  93: "A6",
  94: "B♭6",
  95: "B6",
  96: "C7",
  97: "D♭7",
  98: "D7",
  99: "E♭7",
  100: "E7",
  101: "F7",
  102: "G♭7",
  103: "G7",
  104: "A♭7",
  105: "A7",
  106: "B♭7",
  107: "B7",
  108: "C8",
};

// G
let standardLabels3 = {
  21: "A0",
  22: "B♭0",
  23: "B0",
  24: "C1",
  25: "C♯1",
  26: "D1",
  27: "E♭1",
  28: "E1",
  29: "F1",
  30: "F♯1",
  31: "G1",
  32: "G♯1",
  33: "A1",
  34: "B♭1",
  35: "B1",
  36: "C2",
  37: "C♯2",
  38: "D2",
  39: "E♭2",
  40: "E2",
  41: "F2",
  42: "F♯2",
  43: "G2",
  44: "G♯2",
  45: "A2",
  46: "B♭2",
  47: "B2",
  48: "C3",
  49: "C♯3",
  50: "D3",
  51: "E♭3",
  52: "E3",
  53: "F3",
  54: "F♯3",
  55: "G3",
  56: "G♯3",
  57: "A3",
  58: "B♭3",
  59: "B3",
  60: "C4",
  61: "C♯4",
  62: "D4",
  63: "E♭4",
  64: "E4",
  65: "F4",
  66: "F♯4",
  67: "G4",
  68: "G♯4",
  69: "A4",
  70: "B♭4",
  71: "B4",
  72: "C5",
  73: "C♯5",
  74: "D5",
  75: "E♭5",
  76: "E5",
  77: "F5",
  78: "F♯5",
  79: "G5",
  80: "G♯5",
  81: "A5",
  82: "B♭5",
  83: "B5",
  84: "C6",
  85: "C♯6",
  86: "D6",
  87: "E♭6",
  88: "E6",
  89: "F6",
  90: "F♯6",
  91: "G6",
  92: "G♯6",
  93: "A6",
  94: "B♭6",
  95: "B6",
  96: "C7",
  97: "C♯7",
  98: "D7",
  99: "E♭7",
  100: "E7",
  101: "F7",
  102: "F♯7",
  103: "G7",
  104: "G♯7",
  105: "A7",
  106: "B♭7",
  107: "B7",
  108: "C8",
};
// D♭
let standardLabels4 = {
  21: "B♭♭0",
  22: "B♭0",
  23: "C♭0",
  24: "C1",
  25: "D♭1",
  26: "D1",
  27: "E♭1",
  28: "E1",
  29: "F1",
  30: "G♭1",
  31: "G1",
  32: "A♭1",
  33: "B♭♭1",
  34: "B♭1",
  35: "C♭1",
  36: "C2",
  37: "D♭2",
  38: "D2",
  39: "E♭2",
  40: "E2",
  41: "F2",
  42: "G♭2",
  43: "G2",
  44: "A♭2",
  45: "B♭♭2",
  46: "B♭2",
  47: "C♭2",
  48: "C3",
  49: "D♭3",
  50: "D3",
  51: "E♭3",
  52: "E3",
  53: "F3",
  54: "G♭3",
  55: "G3",
  56: "A♭3",
  57: "B♭♭3",
  58: "B♭3",
  59: "C♭3",
  60: "C4",
  61: "D♭4",
  62: "D4",
  63: "E♭4",
  64: "E4",
  65: "F4",
  66: "G♭4",
  67: "G4",
  68: "A♭4",
  69: "B♭♭4",
  70: "B♭4",
  71: "C♭4",
  72: "C5",
  73: "D♭5",
  74: "D5",
  75: "E♭5",
  76: "E5",
  77: "F5",
  78: "G♭5",
  79: "G5",
  80: "A♭5",
  81: "B♭♭5",
  82: "B♭5",
  83: "C♭5",
  84: "C6",
  85: "D♭6",
  86: "D6",
  87: "E♭6",
  88: "E6",
  89: "F6",
  90: "G♭6",
  91: "G6",
  92: "A♭6",
  93: "B♭♭6",
  94: "B♭6",
  95: "C♭6",
  96: "C7",
  97: "D♭7",
  98: "D7",
  99: "E♭7",
  100: "E7",
  101: "F7",
  102: "G♭7",
  103: "G7",
  104: "A♭7",
  105: "B♭♭7",
  106: "B♭7",
  107: "C♭7",
  108: "C8",
};
// F♯
let standardLabels5 = {
  21: "A0",
  22: "A♯0",
  23: "B0",
  24: "B♯0",
  25: "C♯1",
  26: "D1",
  27: "D♯1",
  28: "E1",
  29: "E♯1",
  30: "F♯1",
  31: "FX1", // F♯♯ or F double sharp
  32: "G♯1",
  33: "A1",
  34: "A♯1",
  35: "B1",
  36: "B♯1",
  37: "C♯2",
  38: "D2",
  39: "D♯2",
  40: "E2",
  41: "E♯2",
  42: "F♯2",
  43: "FX2", // F♯♯ or F double sharp
  44: "G♯2",
  45: "A2",
  46: "A♯2",
  47: "B2",
  48: "B♯2",
  49: "C♯3",
  50: "D3",
  51: "D♯3",
  52: "E3",
  53: "E♯3",
  54: "F♯3",
  55: "FX3", // F♯♯ or F double sharp
  56: "G♯3",
  57: "A3",
  58: "A♯3",
  59: "B3",
  60: "B♯3",
  61: "C♯4",
  62: "D4",
  63: "D♯4",
  64: "E4",
  65: "E♯4",
  66: "F♯4",
  67: "FX4", // F♯♯ or F double sharp
  68: "G♯4",
  69: "A4",
  70: "A♯4",
  71: "B4",
  72: "B♯4",
  73: "C♯5",
  74: "D5",
  75: "D♯5",
  76: "E5",
  77: "E♯5",
  78: "F♯5",
  79: "FX5", // F♯♯ or F double sharp
  80: "G♯5",
  81: "A5",
  82: "A♯5",
  83: "B5",
  84: "B♯5",
  85: "C♯6",
  86: "D6",
  87: "D♯6",
  88: "E6",
  89: "E♯6",
  90: "F♯6",
  91: "FX6", // F♯♯ or F double sharp
  92: "G♯6",
  93: "A6",
  94: "A♯6",
  95: "B6",
  96: "B♯6",
  97: "C♯7",
  98: "D7",
  99: "D♯7",
  100: "E7",
  101: "E♯7",
  102: "F♯7",
  103: "FX7", // F♯♯ or F double sharp
  104: "G♯7",
  105: "A7",
  106: "A♯7",
  107: "B7",
  108: "B♯7",
};
// c
let standardLabels6 = {
  21: "A0",
  22: "B♭0",
  23: "B0",
  24: "C1",
  25: "C♯1",
  26: "D1",
  27: "E♭1",
  28: "E1",
  29: "F1",
  30: "F♯1",
  31: "G1",
  32: "A♭1",
  33: "A1",
  34: "B♭1",
  35: "B1",
  36: "C2",
  37: "C♯2",
  38: "D2",
  39: "E♭2",
  40: "E2",
  41: "F2",
  42: "F♯2",
  43: "G2",
  44: "A♭2",
  45: "A2",
  46: "B♭2",
  47: "B2",
  48: "C3",
  49: "C♯3",
  50: "D3",
  51: "E♭3",
  52: "E3",
  53: "F3",
  54: "F♯3",
  55: "G3",
  56: "A♭3",
  57: "A3",
  58: "B♭3",
  59: "B3",
  60: "C4",
  61: "C♯4",
  62: "D4",
  63: "E♭4",
  64: "E4",
  65: "F4",
  66: "F♯4",
  67: "G4",
  68: "A♭4",
  69: "A4",
  70: "B♭4",
  71: "B4",
  72: "C5",
  73: "C♯5",
  74: "D5",
  75: "E♭5",
  76: "E5",
  77: "F5",
  78: "F♯5",
  79: "G5",
  80: "A♭5",
  81: "A5",
  82: "B♭5",
  83: "B5",
  84: "C6",
  85: "C♯6",
  86: "D6",
  87: "E♭6",
  88: "E6",
  89: "F6",
  90: "F♯6",
  91: "G6",
  92: "A♭6",
  93: "A6",
  94: "B♭6",
  95: "B6",
  96: "C7",
  97: "C♯7",
  98: "D7",
  99: "E♭7",
  100: "E7",
  101: "F7",
  102: "F♯7",
  103: "G7",
  104: "A♭7",
  105: "A7",
  106: "B♭7",
  107: "B7",
  108: "C8",
};
// D
let standardLabels7 = {
  21: "A0",
  22: "B♭0",
  23: "B0",
  24: "C1",
  25: "C♯1",
  26: "D1",
  27: "D♯1",
  28: "E1",
  29: "F1",
  30: "F♯1",
  31: "G1",
  32: "G♯1",
  33: "A1",
  34: "B♭1",
  35: "B1",
  36: "C2",
  37: "C♯2",
  38: "D2",
  39: "D♯2",
  40: "E2",
  41: "F2",
  42: "F♯2",
  43: "G2",
  44: "G♯2",
  45: "A2",
  46: "B♭2",
  47: "B2",
  48: "C3",
  49: "C♯3",
  50: "D3",
  51: "D♯3",
  52: "E3",
  53: "F3",
  54: "F♯3",
  55: "G3",
  56: "G♯3",
  57: "A3",
  58: "B♭3",
  59: "B3",
  60: "C4",
  61: "C♯4",
  62: "D4",
  63: "D♯4",
  64: "E4",
  65: "F4",
  66: "F♯4",
  67: "G4",
  68: "G♯4",
  69: "A4",
  70: "B♭4",
  71: "B4",
  72: "C5",
  73: "C♯5",
  74: "D5",
  75: "D♯5",
  76: "E5",
  77: "F5",
  78: "F♯5",
  79: "G5",
  80: "G♯5",
  81: "A5",
  82: "B♭5",
  83: "B5",
  84: "C6",
  85: "C♯6",
  86: "D6",
  87: "D♯6",
  88: "E6",
  89: "F6",
  90: "F♯6",
  91: "G6",
  92: "G♯6",
  93: "A6",
  94: "B♭6",
  95: "B6",
  96: "C7",
  97: "C♯7",
  98: "D7",
  99: "D♯7",
  100: "E7",
  101: "F7",
  102: "F♯7",
  103: "G7",
  104: "G♯7",
  105: "A7",
  106: "B♭7",
  107: "B7",
  108: "C8",
};
// E
let standardLabels8 = {
  21: "A0",
  22: "A♯0",
  23: "B0",
  24: "C1",
  25: "C♯1",
  26: "D1",
  27: "D♯1",
  28: "E1",
  29: "E♯1",
  30: "F♯1",
  31: "G1",
  32: "G♯1",
  33: "A1",
  34: "A♯1",
  35: "B1",
  36: "C2",
  37: "C♯2",
  38: "D2",
  39: "D♯2",
  40: "E2",
  41: "E♯2",
  42: "F♯2",
  43: "G2",
  44: "G♯2",
  45: "A2",
  46: "A♯2",
  47: "B2",
  48: "C3",
  49: "C♯3",
  50: "D3",
  51: "D♯3",
  52: "E3",
  53: "E♯3",
  54: "F♯3",
  55: "G3",
  56: "G♯3",
  57: "A3",
  58: "A♯3",
  59: "B3",
  60: "C4",
  61: "C♯4",
  62: "D4",
  63: "D♯4",
  64: "E4",
  65: "E♯4",
  66: "F♯4",
  67: "G4",
  68: "G♯4",
  69: "A4",
  70: "A♯4",
  71: "B4",
  72: "C5",
  73: "C♯5",
  74: "D5",
  75: "D♯5",
  76: "E5",
  77: "E♯5",
  78: "F♯5",
  79: "G5",
  80: "G♯5",
  81: "A5",
  82: "A♯5",
  83: "B5",
  84: "C6",
  85: "C♯6",
  86: "D6",
  87: "D♯6",
  88: "E6",
  89: "E♯6",
  90: "F♯6",
  91: "G6",
  92: "G♯6",
  93: "A6",
  94: "A♯6",
  95: "B6",
  96: "C7",
  97: "C♯7",
  98: "D7",
  99: "D♯7",
  100: "E7",
  101: "E♯7",
  102: "F♯7",
  103: "G7",
  104: "G♯7",
  105: "A7",
  106: "A♯7",
  107: "B7",
  108: "C8",
};
// B
let standardLabels9 = {
  21: "A0",
  22: "A♯0",
  23: "B0",
  24: "B♯1",
  25: "C♯1",
  26: "D1",
  27: "D♯1",
  28: "E1",
  29: "E♯1",
  30: "F♯1",
  31: "G1",
  32: "G♯1",
  33: "A1",
  34: "A♯1",
  35: "B1",
  36: "B♯2",
  37: "C♯2",
  38: "D2",
  39: "D♯2",
  40: "E2",
  41: "E♯2",
  42: "F♯2",
  43: "G2",
  44: "G♯2",
  45: "A2",
  46: "A♯2",
  47: "B2",
  48: "B♯3",
  49: "C♯3",
  50: "D3",
  51: "D♯3",
  52: "E3",
  53: "E♯3",
  54: "F♯3",
  55: "G3",
  56: "G♯3",
  57: "A3",
  58: "A♯3",
  59: "B3",
  60: "B♯4",
  61: "C♯4",
  62: "D4",
  63: "D♯4",
  64: "E4",
  65: "E♯4",
  66: "F♯4",
  67: "G4",
  68: "G♯4",
  69: "A4",
  70: "A♯4",
  71: "B4",
  72: "B♯5",
  73: "C♯5",
  74: "D5",
  75: "D♯5",
  76: "E5",
  77: "E♯5",
  78: "F♯5",
  79: "G5",
  80: "G♯5",
  81: "A5",
  82: "A♯5",
  83: "B5",
  84: "B♯6",
  85: "C♯6",
  86: "D6",
  87: "D♯6",
  88: "E6",
  89: "E♯6",
  90: "F♯6",
  91: "G6",
  92: "G♯6",
  93: "A6",
  94: "A♯6",
  95: "B6",
  96: "B♯7",
  97: "C♯7",
  98: "D7",
  99: "D♯7",
  100: "E7",
  101: "E♯7",
  102: "F♯7",
  103: "G7",
  104: "G♯7",
  105: "A7",
  106: "A♯7",
  107: "B7",
  108: "B♯8",
};
// C♯
let standardLabels10 = {
  21: "A0",
  22: "A♯0",
  23: "B0",
  24: "B♯1",
  25: "C♯1",
  26: "D1",
  27: "D♯1",
  28: "E1",
  29: "F1",
  30: "F♯1",
  31: "G1",
  32: "G♯1",
  33: "A1",
  34: "A♯1",
  35: "B1",
  36: "B♯2",
  37: "C♯2",
  38: "D2",
  39: "D♯2",
  40: "E2",
  41: "F2",
  42: "F♯2",
  43: "G2",
  44: "G♯2",
  45: "A2",
  46: "A♯2",
  47: "B2",
  48: "B♯3",
  49: "C♯3",
  50: "D3",
  51: "D♯3",
  52: "E3",
  53: "F3",
  54: "F♯3",
  55: "G3",
  56: "G♯3",
  57: "A3",
  58: "A♯3",
  59: "B3",
  60: "B♯4",
  61: "C♯4",
  62: "D4",
  63: "D♯4",
  64: "E4",
  65: "F4",
  66: "F♯4",
  67: "G4",
  68: "G♯4",
  69: "A4",
  70: "A♯4",
  71: "B4",
  72: "B♯5",
  73: "C♯5",
  74: "D5",
  75: "D♯5",
  76: "E5",
  77: "F5",
  78: "F♯5",
  79: "G5",
  80: "G♯5",
  81: "A5",
  82: "A♯5",
  83: "B5",
  84: "B♯6",
  85: "C♯6",
  86: "D6",
  87: "D♯6",
  88: "E6",
  89: "F6",
  90: "F♯6",
  91: "G6",
  92: "G♯6",
  93: "A6",
  94: "A♯6",
  95: "B6",
  96: "B♯7",
  97: "C♯7",
  98: "D7",
  99: "D♯7",
  100: "E7",
  101: "F7",
  102: "F♯7",
  103: "G7",
  104: "G♯7",
  105: "A7",
  106: "A♯7",
  107: "B7",
  108: "B♯8",
};
// A♭
let standardLabels11 = {
  21: "A0",
  22: "B♭0",
  23: "B0",
  24: "C1",
  25: "D♭1",
  26: "D1",
  27: "E♭1",
  28: "F♭1",
  29: "F1",
  30: "G♭1",
  31: "G1",
  32: "A♭1",
  33: "A1",
  34: "B♭1",
  35: "B1",
  36: "C2",
  37: "D♭2",
  38: "D2",
  39: "E♭2",
  40: "F♭2",
  41: "F2",
  42: "G♭2",
  43: "G2",
  44: "A♭2",
  45: "A2",
  46: "B♭2",
  47: "B2",
  48: "C3",
  49: "D♭3",
  50: "D3",
  51: "E♭3",
  52: "F♭3",
  53: "F3",
  54: "G♭3",
  55: "G3",
  56: "A♭3",
  57: "A3",
  58: "B♭3",
  59: "B3",
  60: "C4",
  61: "D♭4",
  62: "D4",
  63: "E♭4",
  64: "F♭4",
  65: "F4",
  66: "G♭4",
  67: "G4",
  68: "A♭4",
  69: "A4",
  70: "B♭4",
  71: "B4",
  72: "C5",
  73: "D♭5",
  74: "D5",
  75: "E♭5",
  76: "F♭5",
  77: "F5",
  78: "G♭5",
  79: "G5",
  80: "A♭5",
  81: "A5",
  82: "B♭5",
  83: "B5",
  84: "C6",
  85: "D♭6",
  86: "D6",
  87: "E♭6",
  88: "F♭6",
  89: "F6",
  90: "G♭6",
  91: "G6",
  92: "A♭6",
  93: "A6",
  94: "B♭6",
  95: "B6",
  96: "C7",
  97: "D♭7",
  98: "D7",
  99: "E♭7",
  100: "F♭7",
  101: "F7",
  102: "G♭7",
  103: "G7",
  104: "A♭7",
  105: "A7",
  106: "B♭7",
  107: "B7",
  108: "C8",
};
// G♯
let standardLabels12 = {
  21: "A0",
  22: "A♯0",
  23: "B0",
  24: "C1",
  25: "C♯1",
  26: "D1",
  27: "D♯1",
  28: "E1",
  29: "E♯1",
  30: "F♯1",
  31: "FX1",
  32: "G♯1",
  33: "A1",
  34: "A♯1",
  35: "B1",
  36: "C2",
  37: "C♯2",
  38: "D2",
  39: "D♯2",
  40: "E2",
  41: "E♯2",
  42: "F♯2",
  43: "FX2",
  44: "G♯2",
  45: "A2",
  46: "A♯2",
  47: "B2",
  48: "C3",
  49: "C♯3",
  50: "D3",
  51: "D♯3",
  52: "E3",
  53: "E♯3",
  54: "F♯3",
  55: "FX3",
  56: "G♯3",
  57: "A3",
  58: "A♯3",
  59: "B3",
  60: "C4",
  61: "C♯4",
  62: "D4",
  63: "D♯4",
  64: "E4",
  65: "E♯4",
  66: "F♯4",
  67: "FX4",
  68: "G♯4",
  69: "A4",
  70: "A♯4",
  71: "B4",
  72: "C5",
  73: "C♯5",
  74: "D5",
  75: "D♯5",
  76: "E5",
  77: "E♯5",
  78: "F♯5",
  79: "FX5",
  80: "G♯5",
  81: "A5",
  82: "A♯5",
  83: "B5",
  84: "C6",
  85: "C♯6",
  86: "D6",
  87: "D♯6",
  88: "E6",
  89: "E♯6",
  90: "F♯6",
  91: "FX6",
  92: "G♯6",
  93: "A6",
  94: "A♯6",
  95: "B6",
  96: "C7",
  97: "C♯7",
  98: "D7",
  99: "D♯7",
  100: "E7",
  101: "E♯7",
  102: "F♯7",
  103: "FX7",
  104: "G♯7",
  105: "A7",
  106: "A♯7",
  107: "B7",
  108: "C8",
};
// E♭
let standardLabels13 = {
  21: "A0",
  22: "B♭0",
  23: "C♭0",
  24: "C1",
  25: "D♭1",
  26: "D1",
  27: "E♭1",
  28: "E1",
  29: "F1",
  30: "G♭1",
  31: "G1",
  32: "A♭1",
  33: "A1",
  34: "B♭1",
  35: "C♭1",
  36: "C2",
  37: "D♭2",
  38: "D2",
  39: "E♭2",
  40: "E2",
  41: "F2",
  42: "G♭2",
  43: "G2",
  44: "A♭2",
  45: "A2",
  46: "B♭2",
  47: "C♭2",
  48: "C3",
  49: "D♭3",
  50: "D3",
  51: "E♭3",
  52: "E3",
  53: "F3",
  54: "G♭3",
  55: "G3",
  56: "A♭3",
  57: "A3",
  58: "B♭3",
  59: "C♭3",
  60: "C4",
  61: "D♭4",
  62: "D4",
  63: "E♭4",
  64: "E4",
  65: "F4",
  66: "G♭4",
  67: "G4",
  68: "A♭4",
  69: "A4",
  70: "B♭4",
  71: "C♭4",
  72: "C5",
  73: "D♭5",
  74: "D5",
  75: "E♭5",
  76: "E5",
  77: "F5",
  78: "G♭5",
  79: "G5",
  80: "A♭5",
  81: "A5",
  82: "B♭5",
  83: "C♭5",
  84: "C6",
  85: "D♭6",
  86: "D6",
  87: "E♭6",
  88: "E6",
  89: "F6",
  90: "G♭6",
  91: "G6",
  92: "A♭6",
  93: "A6",
  94: "B♭6",
  95: "C♭6",
  96: "C7",
  97: "D♭7",
  98: "D7",
  99: "E♭7",
  100: "E7",
  101: "F7",
  102: "G♭7",
  103: "G7",
  104: "A♭7",
  105: "A7",
  106: "B♭7",
  107: "C♭7",
  108: "C8",
};
// F
let standardLabels14 = {
  21: "A0",
  22: "B♭0",
  23: "B0",
  24: "C1",
  25: "D♭1",
  26: "D1",
  27: "E♭1",
  28: "E1",
  29: "F1",
  30: "F♯1",
  31: "G1",
  32: "A♭1",
  33: "A1",
  34: "B♭1",
  35: "B1",
  36: "C2",
  37: "D♭2",
  38: "D2",
  39: "E♭2",
  40: "E2",
  41: "F2",
  42: "F♯2",
  43: "G2",
  44: "A♭2",
  45: "A2",
  46: "B♭2",
  47: "B2",
  48: "C3",
  49: "D♭3",
  50: "D3",
  51: "E♭3",
  52: "E3",
  53: "F3",
  54: "F♯3",
  55: "G3",
  56: "A♭3",
  57: "A3",
  58: "B♭3",
  59: "B3",
  60: "C4",
  61: "D♭4",
  62: "D4",
  63: "E♭4",
  64: "E4",
  65: "F4",
  66: "F♯4",
  67: "G4",
  68: "A♭4",
  69: "A4",
  70: "B♭4",
  71: "B4",
  72: "C5",
  73: "D♭5",
  74: "D5",
  75: "E♭5",
  76: "E5",
  77: "F5",
  78: "F♯5",
  79: "G5",
  80: "A♭5",
  81: "A5",
  82: "B♭5",
  83: "B5",
  84: "C6",
  85: "D♭6",
  86: "D6",
  87: "E♭6",
  88: "E6",
  89: "F6",
  90: "F♯6",
  91: "G6",
  92: "A♭6",
  93: "A6",
  94: "B♭6",
  95: "B6",
  96: "C7",
  97: "D♭7",
  98: "D7",
  99: "E♭7",
  100: "E7",
  101: "F7",
  102: "F♯7",
  103: "G7",
  104: "A♭7",
  105: "A7",
  106: "B♭7",
  107: "B7",
  108: "C8",
};

let note = [
  "A",
  "A♯",
  "B",
  "C",
  "C♯",
  "D",
  "D♯",
  "E",
  "F",
  "F♯",
  "G",
  "G♯",
  "A",
  "A♯",
  "B",
  "C",
  "C♯",
  "D",
  "D♯",
  "E",
  "F",
  "F♯",
  "G",
  "G♯",
];

let note2 = ["A", "B♭", "B", "C", "D♭", "D", "E♭", "E", "F", "G♭", "G", "A♭"];

let note3 = ["A", "B♭", "B", "C", "C♯", "D", "E♭", "E", "F", "F♯", "G", "G♯"];

let note4 = [
  "B♭♭",
  "B♭",
  "C♭",
  "C",
  "D♭",
  "D",
  "E♭",
  "E",
  "F",
  "G♭",
  "G",
  "A♭",
];

let note5 = [
  "A",
  "A♯",
  "B",
  "B♯",
  "C♯",
  "D",
  "D♯",
  "E",
  "E♯",
  "F♯",
  "FX",
  "G♯",
];

let note6 = ["A", "B♭", "B", "C", "C♯", "D", "E♭", "E", "F", "F♯", "G", "A♭"];

let note7 = ["A", "B♭", "B", "C", "C♯", "D", "D♯", "E", "F", "F♯", "G", "G♯"];

let note8 = ["A", "A♯", "B", "C", "C♯", "D", "D♯", "E", "E♯", "F♯", "G", "G♯"];

let note9 = ["A", "A♯", "B", "B♯", "C♯", "D", "D♯", "E", "E♯", "F♯", "G", "G♯"];

let note10 = ["A", "A♯", "B", "B♯", "C♯", "D", "D♯", "E", "F", "F♯", "G", "G♯"];

let note11 = ["A", "B♭", "B", "C", "D♭", "D", "E♭", "F♭", "F", "G♭", "G", "A♭"];

let note12 = [
  "A",
  "A♯",
  "B",
  "C",
  "C♯",
  "D",
  "D♯",
  "E",
  "E♯",
  "F♯",
  "FX",
  "G♯",
];
let note13 = ["A", "B♭", "C♭", "C", "D♭", "D", "E♭", "E", "F", "G♭", "G", "A♭"];
let note14 = ["A", "B♭", "B", "C", "D♭", "D", "E♭", "E", "F", "F♯", "G", "A♭"];

// Tonal Scale
let tonalA = ["A", "A♯", "B", "C", "C♯", "D", "D♯", "E", "F", "F♯", "G", "G♯"];
let tonalBb = ["A", "B♭", "B", "C", "D♭", "D", "E♭", "E", "F", "G♭", "G", "A♭"];
let tonalG = ["A", "B♭", "B", "C", "C♯", "D", "E♭", "E", "F", "F♯", "G", "G♯"];
let tonalDb = [
  "B𝄫",
  "B♭",
  "C♭",
  "C",
  "D♭",
  "D",
  "E♭",
  "F♭",
  "F",
  "G♭",
  "G",
  "A♭",
];
let tonalFSharp = [
  "A",
  "A♯",
  "B",
  "B♯",
  "C♯",
  "D",
  "D♯",
  "E",
  "E♯",
  "F♯",
  "G",
  "G♯",
];
let tonalC = ["A", "B♭", "B", "C", "C♯", "D", "E♭", "E", "F", "F♯", "G", "A♭"];
let tonalD = ["A", "B♭", "B", "C", "C♯", "D", "D♯", "E", "F", "F♯", "G", "G♯"];
let tonalE = ["A", "A♯", "B", "C", "C♯", "D", "D♯", "E", "E♯", "F♯", "G", "G♯"];
let tonalB = [
  "A",
  "A♯",
  "B",
  "B♯",
  "C♯",
  "D",
  "D♯",
  "E",
  "E♯",
  "F♯",
  "G",
  "G♯",
];
let tonalCSharp = [
  "A",
  "A♯",
  "B",
  "B♯",
  "C♯",
  "D",
  "D♯",
  "E",
  "F",
  "F♯",
  "G",
  "G♯",
];
let tonalAb = [
  "A",
  "B♭",
  "C♭",
  "C",
  "D♭",
  "D",
  "E♭",
  "F♭",
  "F",
  "G♭",
  "G",
  "A♭",
];
let tonalGSharp = [
  "A",
  "A♯",
  "B",
  "C",
  "C♯",
  "D",
  "D♯",
  "E",
  "E♯",
  "F♯",
  "F𝄪",
  "G♯",
];
let tonalEb = [
  "A",
  "B♭",
  "C♭",
  "C",
  "D♭",
  "D",
  "E♭",
  "E",
  "F",
  "G♭",
  "G",
  "A♭",
];
let tonalF = ["A", "B♭", "B", "C", "D♭", "D", "E♭", "E", "F", "F♯", "G", "A♭"];

//Hexahonic
let hexaC = ["A", "A♯", "A𝄪", "C", "D♭", "D", "D♯", "E", "F", "F♯", "F𝄪", "G♯"];
let hexaCSharp = ["A", "A♯", "C♭", "C", "C♯", "D", "E♭", "E", "E♯", "F♯", "G", "G♯"];
let hexaDb = [
  "A",
  "B♭",
  "B",
  "B♯",
  "D♭",
  "D",
  "D♯",
  "E",
  "F",
  "F♯",
  "F𝄪",
  "G♯",
];
let hexaD = [
  "G𝄪",
  "A♯",
  "B",
  "B♯",
  "B𝄪",
  "D",
  "E♭",
  "E",
  "E♯",
  "F♯",
  "G",
  "G♯",
];
let hexaEb = [
  "A",
  "A♯",
  "B",
  "C",
  "C♯",
  "C𝄪",
  "E♭",
  "F♭",
  "F",
  "F♯",
  "G",
  "A♭",
];
let hexaE = ["A", "A♯", "B", "B♯", "C♯", "C𝄪", "E♭", "E", "F", "F♯", "G", "G♯"];
let hexaF = ["A", "B♭", "B", "B♯", "C♯", "D", "D♯", "D𝄪", "F", "G♭", "G", "G♯"];
let hexaGb = [ "A", "B♭", "C♭", "C", "C♯", "D", "E♭", "E", "E♯", "G♭", "G", "A♭"];
let hexaG = ["A", "A♯", "B", "C", "C♯", "C𝄪", "D♯", "E", "E♯", "E𝄪", "G", "A♭"];
let hexaAb = [
  "B𝄫",
  "B♭",
  "B",
  "C",
  "D♭",
  "D",
  "D♯",
  "E",
  "F",
  "F♯",
  "F𝄪",
  "A♭",
];
let hexaBb = [
  "B𝄫",
  "B♭",
  "C♭",
  "C",
  "D♭",
  "D",
  "E♭",
  "E",
  "F",
  "F♯",
  "G",
  "G♯",
];
let hexaBbb = ["B𝄫", "B♭", "B", "C", "D♭", "D", "D♯", "E", "F", "G♭", "G", "G♯"];
let hexaB = ["A", "A♯", "B", "C", "C♯", "C𝄪", "D", "E", "E♯", "E𝄪", "F𝄪", "A♭"];
let hexaA = ["A", "B♭", "B", "C", "C♯", "D", "D♯", "E", "F", "F♯", "F𝄪", "A♭"];
let hexaFSharp = [
  "A",
  "A♯",
  "B",
  "B♯",
  "C♯",
  "D",
  "D♯",
  "D𝄪",
  "F",
  "F♯",
  "G",
  "G♯",
];

//Octophonic
let octoC = [
  "B𝄫",
  "C𝄫",
  "C♭",
  "C",
  "D♭",
  "D",
  "E♭",
  "F♭",
  "F",
  "G♭",
  "A𝄫",
  "A♭",
];
let octoCSharp = [
  "A",
  "B♭",
  "C♭",
  "C",
  "C♯",
  "D",
  "D♯",
  "E",
  "F",
  "F♯",
  "G",
  "A♭",
];
let octoD = [
  "B𝄫",
  "B♭",
  "C♭",
  "D𝄫",
  "D♭",
  "D",
  "E♭",
  "E",
  "F",
  "G♭",
  "G",
  "A♭",
];
let octoDSharp = [
  "A",
  "B♭",
  "B",
  "C",
  "D♭",
  "D",
  "D♯",
  "E",
  "E♯",
  "F♯",
  "G",
  "G♯",
];
let octoE = ["A", "B♭", "C♭", "C", "D♭", "E𝄫", "E♭", "E", "F", "F♯", "G", "A♭"];
let octoESharp = [
  "A",
  "A♯",
  "B",
  "C",
  "C♯",
  "D",
  "E♭",
  "E",
  "E♯",
  "F",
  "F♯",
  "G♯",
];
let octoF = [
  "A",
  "B♭",
  "C♭",
  "C",
  "D♭",
  "E𝄫",
  "E♭",
  "F♭",
  "F",
  "G♭",
  "G",
  "A♭",
];
let octoFSharp = [
  "A",
  "B♭",
  "B",
  "C",
  "D♭",
  "D",
  "E𝄫",
  "F♭",
  "F",
  "F♯",
  "G",
  "G♯",
];
let octoG = [
  "A",
  "B♭",
  "C♭",
  "C",
  "D♭",
  "E𝄫",
  "E♭",
  "F♭",
  "G𝄫",
  "G♭",
  "G",
  "A♭",
];
let octoGSharp = [
  "A",
  "A♯",
  "B",
  "B♯",
  "C♯",
  "D",
  "D♯",
  "E",
  "F",
  "F♯",
  "G",
  "G♯",
];
let octoA = ["A", "B♭", "B", "C", "D♭", "D", "E♭", "F♭", "F", "G♭", "A𝄫", "A♭"];
let octoASharp = [
  "A",
  "A♯",
  "B",
  "B♯",
  "C♯",
  "C𝄪",
  "D♯",
  "E",
  "E♯",
  "F♯",
  "G",
  "G♯",
];
let octoB = ["B𝄫", "B♭", "B", "C", "C♯", "D", "E♭", "E", "F", "G♭", "G", "A♭"];

export {
  standardLabels,
  standardLabels2,
  standardLabels3,
  standardLabels4,
  standardLabels5,
  standardLabels6,
  standardLabels7,
  standardLabels8,
  standardLabels9,
  standardLabels10,
  standardLabels11,
  standardLabels12,
  standardLabels13,
  standardLabels14,
  note,
  note2,
  note3,
  note4,
  note5,
  note6,
  note7,
  note8,
  note9,
  note10,
  note11,
  note12,
  note13,
  note14,
  tonalA,
  tonalAb,
  tonalC,
  tonalCSharp,
  tonalD,
  tonalDb,
  tonalE,
  tonalEb,
  tonalF,
  tonalFSharp,
  tonalB,
  tonalBb,
  tonalGSharp,
  tonalG,
  hexaA,
  hexaAb,
  hexaB,
  hexaBb,
  hexaBbb,
  hexaC,
  hexaCSharp,
  hexaD,
  hexaDb,
  hexaE,
  hexaEb,
  hexaF,
  hexaFSharp,
  hexaG,
  hexaGb,
  octoA,
  octoASharp,
  octoB,
  octoC,
  octoCSharp,
  octoD,
  octoDSharp,
  octoE,
  octoESharp,
  octoF,
  octoFSharp,
  octoG,
  octoGSharp,
};
